import React, { Component } from "react";
import "./App.css";
import history from "../history";
import { network } from "../Network";
import Config from "../../Config";

class App extends Component {
  constructor(props) {
    super(props);

    this.config = new Config();

    let livenet = this.config.conf.LIVENET;

    this.state = {
      currencyMenu: false,
      currency: "XDB",
      scan: false,
      search: "",
      livenet: livenet,
      searchError: "",
    };
  }

  search(event, ignoreEvent) {
    this.setState({ searchError: "" });
    if (
      (event.key === "Enter" || ignoreEvent === true) &&
      this.state.search.length
    ) {
      let value = this.state.search;
      network.getAccount(
        value,
        (res) => {
          history.push("/address/" + value);
          this.setState({ search: "" });
        },
        (err) => {
          network.getTransaction(
            value,
            (res) => {
              history.push("/transaction/" + value);
              this.setState({ search: "" });
            },
            (err) => {
              network.getLedger(
                value,
                (res) => {
                  history.push("/sequence/" + value);
                  this.setState({ search: "" });
                },
                (err) => {
                  network.getLiquidityPool(
                    value,
                    (res) => {
                      history.push("/liquidity_pool/" + value);
                      this.setState({ search: "" });
                    },
                    (err) => {
                      this.setState({ searchError: "Error, not found" });
                    }
                  );
                }
              );
            }
          );
        }
      );
    }
  }

  render() {
    return (
      <div className="app">
        <header className="app-header">
          <div className="app-header-container">
            <button
              type="button"
              className="app-logo"
              onClick={() => {
                this.setState({ search: "" });
                history.push("/");
              }}
            >
              XDB CHAIN Explorer
            </button>
            <button
              className="app-link"
              type="button"
              onClick={() => {
                this.setState({ search: "" });
                history.push("/network_overview");
              }}
            >
              Network Overview
            </button>
            <div className="app-nav">
              <input
                value={this.state.search}
                onChange={(e) => {
                  this.setState({ search: e.target.value });
                  this.setState({ searchError: "" });
                }}
                onKeyPress={(e) => {
                  this.search(e, false);
                }}
                className="app-search"
                placeholder="Address, transaction, ledger sequence or liquidity pool"
              />
              <button
                type="button"
                className="app-search-button"
                onClick={(e) => {
                  this.search(e, true);
                }}
              ></button>
              <div className="app-search-error">{this.state.searchError}</div>
            </div>
          </div>
        </header>
        <div className="app-content">
          {React.cloneElement(this.props.children, {
            currency: this.state.currency,
            initialState: this.props.route.initialState,
          })}
        </div>
        <div className="app-footer">
          <div className="app-footer-container">
            &copy; {new Date().getFullYear()} XDBChain. All Rights
            Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js